import { extend, groupedTranslations } from "@taager/localization";
import {
  arValidationTranslation,
  enValidationTranslation,
} from "@taager/react-form";
import aboutUsTranslation from "localization/about-us.json";
import authTranslation from "localization/auth.json";
import cartTranslation from "localization/cart.json";
import catalogTranslation from "localization/catalog.json";
import checkoutTranslation from "localization/checkout.json";
import commonTranslation from "localization/common.json";
import countriesTranslation from "localization/countries.json";
import currenciesTranslation from "localization/currencies.json";
import customCheckoutTranslation from "localization/custom-product-checkout.json";
import designSystem from "localization/design-system.json";
import formTranslation from "localization/form.json";
import homeTranslation from "localization/home.json";
import incentivesTranslation from "localization/incentives.json";
import infoTranslation from "localization/info.json";
import insightsTranslation from "localization/insights.json";
import learningTranslation from "localization/learning.json";
import lockedOnYouTranslation from "localization/locked-on-you.json";
import monthsTranslation from "localization/months.json";
import navigationTranslation from "localization/navigation.json";
import oldTranslation from "localization/old.json";
import ordersTranslation from "localization/orders.json";
import paginationTranslation from "localization/pagination.json";
import preOrdersTranslation from "localization/pre-orders.json";
import privacyPolicyTranslation from "localization/privacy-policy.json";
import productsTranslation from "localization/products.json";
import profileTranslation from "localization/profile.json";
import recommendationsTranslation from "localization/recommendations.json";
import registrationTranslation from "localization/registration.json";
import statusesTranslation from "localization/statuses.json";
import storesTranslation from "localization/stores.json";
import termsConditionsTranslation from "localization/terms-conditions.json";
import tieringTranslation from "localization/tiering.json";
import walletTranslation from "localization/wallet.json";
import referralProgramsTranslation from "./referral-programs.json";

extend("en", { validation: enValidationTranslation });
extend("ar", { validation: arValidationTranslation });

groupedTranslations("validation", {
  minDate: {
    en: "The date must be greater than or equal to :date",
    ar: "يجب أن يكون التاريخ أكبر من أو يساوي :date",
  },
  maxDate: {
    en: "The date must be less than or equal to :date",
    ar: "يجب أن يكون التاريخ أقل من أو يساوي :date",
  },
});

groupedTranslations(commonTranslation);
groupedTranslations("countries", countriesTranslation);
groupedTranslations("home", homeTranslation);
groupedTranslations("auth", authTranslation);
groupedTranslations("terms", termsConditionsTranslation);
groupedTranslations("designSystem", designSystem);
groupedTranslations("registration", registrationTranslation);
groupedTranslations("navigation", navigationTranslation);
groupedTranslations("profile", profileTranslation);
groupedTranslations("old", oldTranslation);
groupedTranslations("months", monthsTranslation);
groupedTranslations("stores", storesTranslation);
groupedTranslations("wallet", walletTranslation);
groupedTranslations("currencies", currenciesTranslation);
groupedTranslations("info", infoTranslation);
groupedTranslations("form", formTranslation);
groupedTranslations("statuses", statusesTranslation);
groupedTranslations("insights", insightsTranslation);
groupedTranslations("customCheckout", customCheckoutTranslation);
groupedTranslations("preOrders", preOrdersTranslation);
groupedTranslations("orders", ordersTranslation);
groupedTranslations("pagination", paginationTranslation);
groupedTranslations("catalog", catalogTranslation);
groupedTranslations("checkout", checkoutTranslation);
groupedTranslations("cart", cartTranslation);
groupedTranslations("lockedOnYou", lockedOnYouTranslation);
groupedTranslations("referralPrograms", referralProgramsTranslation);
groupedTranslations("products", productsTranslation);
groupedTranslations("aboutUs", aboutUsTranslation);
groupedTranslations("tiering", tieringTranslation);
groupedTranslations("incentives", incentivesTranslation);
groupedTranslations("recommendations", recommendationsTranslation);
groupedTranslations("privacyPolicy", privacyPolicyTranslation);
groupedTranslations("learning", learningTranslation);
